import type { WidgetConfig, WidgetPosition } from "./types";

const DEFAULT_POSITION: WidgetPosition = "bottom-right";
const DEFAULT_PRIMARY_COLOR = "#000000";
const DEFAULT_LOCALE = "fr";

function isPosition(value: string | null): value is WidgetPosition {
  return value === "bottom-right" || value === "bottom-left";
}

function normalizeColor(value: string | null): string {
  if (!value || !/^#[0-9a-f]{6}$/i.test(value)) {
    return DEFAULT_PRIMARY_COLOR;
  }

  return value;
}

export function readWidgetConfig(script: HTMLScriptElement | null): WidgetConfig | null {
  const clientId = script?.dataset.clientId?.trim();
  const configuredApiBaseUrl = script?.dataset.apiBaseUrl?.trim() || __QK_CHAT_API_BASE_URL__;
  const rawPosition = script?.dataset.position ?? null;
  const rawPrimaryColor = script?.dataset.primaryColor ?? null;

  if (!clientId || !configuredApiBaseUrl) {
    return null;
  }

  const positionOverride = isPosition(rawPosition) ? rawPosition : null;
  const primaryColorOverride = rawPrimaryColor ? normalizeColor(rawPrimaryColor) : null;

  return {
    clientId,
    apiBaseUrl: configuredApiBaseUrl.replace(/\/$/, ""),
    position: positionOverride ?? DEFAULT_POSITION,
    positionOverride,
    primaryColor: primaryColorOverride ?? DEFAULT_PRIMARY_COLOR,
    primaryColorOverride,
    locale: script?.dataset.locale?.trim() || DEFAULT_LOCALE,
    debug: script?.dataset.debug === "true"
  };
}

export function getCurrentWidgetScript(): HTMLScriptElement | null {
  if (document.currentScript instanceof HTMLScriptElement) {
    return document.currentScript;
  }

  return document.querySelector("script[data-client-id]");
}
